import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react';
import { CookiesProvider } from 'react-cookie';
import theme from './theme';

import { UserProvider } from './contexts/UserContext';
import { SearchProvider } from './contexts/SearchContext';
import { CartProvider } from './contexts/CartContext';
import { ShopUIProvider } from './contexts/ShopUIContext';
import { AgentProvider } from './ai/AgentProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <UserProvider>
          <SearchProvider>
            <CartProvider>
              <ShopUIProvider>
                <AgentProvider>
                  <CookiesProvider>
                    <App />
                  </CookiesProvider>
                </AgentProvider>
              </ShopUIProvider>
            </CartProvider>
          </SearchProvider>
        </UserProvider>
      </ChakraProvider>
    </BrowserRouter>
  </React.StrictMode>
);
